<template>
<div id="content">
    
    <div id="content-clip-path">

      <div id="image-wrapper">
        <div class="image-slice" 
             :style="'background-size: '+ 576 * zone1.scaleX +'px ; background-position: top ' + zone1.assetY + 'px left '+zone1.assetX+ 'px; background-image: linear-gradient(rgba(153,101,21,0.35), rgba(153,101,21,0.35)), url(\' ' + GALLERY_HOST + '/' + zone1.val + '\');'">
        </div>
        <div class="image-slice" 
             :style="'background-size: '+ 576 * zone1.scaleX +'px ; background-position: top ' + zone1.assetY + 'px left '+zone1.assetX+ 'px; background-image: linear-gradient(rgba(153,101,21,0.35), rgba(153,101,21,0.35)), url(\' ' + GALLERY_HOST + '/'+ zone1.val + '\');'">
        </div>
        <div class="image-slice" 
             :style="'background-size: '+ 576 * zone1.scaleX +'px ; background-position: top ' + zone1.assetY + 'px left '+zone1.assetX+ 'px; background-image: linear-gradient(rgba(153,101,21,0.35), rgba(153,101,21,0.35)), url(\' ' + GALLERY_HOST + '/' + zone1.val + '\');'">
        </div>
      </div><!-- END image-wrapper-->

      <div id="blocks-wrapper">
        <div class="block" :style="zone4.style">
        </div>
        <div class="block" :style="zone4.style">
        </div>
        <div class="block" :style="zone4.style">
        </div>
        <div class="block" :style="zone5.style">
        </div>
        <div class="block" :style="zone5.style">
        </div>
        <div class="block zone-05" :style="zone5.style">
        </div>
      </div><!-- END blocks-wrapper -->
    
    </div><!-- END content-clip-path -->
		
		<div class="stats">
			<div class="stat -position"><label for="position">Position: </label><span>{{zone2.val}}</span></div>
			<div class="stat -name"><label for="name">Name: </label><span>{{zone3.val}}</span></div>
		</div>
      
	</div><!-- END content -->
</template>

<script>
export default {
   data() {
      return {
         zone1: {},
         zone2: {},
         zone3: {},
         zone4: {},
         zone5: {}
      }
   },

   props: {
      json: {}
   },

   created() {
      this.zone1 = this.json.tmpl.assets[0];
      this.zone4 = this.json.tmpl.assets[1];
      this.zone5 = this.json.tmpl.assets[2];

      this.zone2 = this.json.tmpl.data.text[0];
      this.zone3 = this.json.tmpl.data.text[1];
   }
}
</script>

<style lang="scss" scoped>
// vars
// $block: rgba(183,65,14,0.95); // base color of a color block
$block: #fff;
$darken: rgba(0,0,0,.05); // the overlays over a block 
$black: rgba(0,0,0,1); // the black strip sliding over the photo 
$white: rgba(1,1,1,1);
$width: 1920px;
$height: 1080px;
$pageLoad: 6s;
$pageLoadDelay: 5.85s;

* {
  margin: 0;
  padding: 0;
	box-sizing: border-box;
}
body {
  background: $black;
	color: #fff;
  font-family: 'Roboto', serif;
  width: 100vw;
  height: 100vh;
	max-width: $width;
	max-height: $height;
}

#content {
	position: relative;
  width: 100%;
  height: 100%;
	max-width: $width;
	max-height: $height;
  margin: 0 auto;
	overflow: hidden;
}

// Forms the trapezoid around the entire content area 
#content-clip-path {
	width: 100%;
	height: 75%;
	max-width: $width;
	max-height: $height;
//   clip-path: polygon(0 0, 100% 9%, 100% 100%, 0 94%);
}

#image-wrapper {
  display: inline-block;
	position: absolute;
	top: 1%;
	left: 20%;
	width: 1056px; //55% of 1920px
	height: 650px;
	overflow: hidden;
  background-color: $black;
	z-index: 1;
  animation: fadeBothWays $pageLoad forwards ease-in-out;
  
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 1056px;
      height: 100%;
      background-color: rgba(0,0,0,1);
      animation: revealRTL $pageLoad forwards ease-in-out;
    }
  
    // Slices the photo into sprites 
    .image-slice {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      float: left;
      height: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: white;
      background-blend-mode: overlay, luminosity;

      &:nth-of-type(1) {
        width: 176px;
        background-position: left top;
      }

      &:nth-of-type(2) {
        width: 576px;  //75% of 1056px minus the 40px for the margins and the width of the first slice
        margin-right: 25px;
        margin-left: 15px;
        background-position: center top;
      }

      &:nth-of-type(3) {
        width: 96px;
        background-position: right top;
      }
    }
}

// Color blocks 
#blocks-wrapper {
	position: absolute;
	top: 1%;
	left: 1%;
	width: 100%;
	height: 100%;
	z-index: 5;
  transform-style: preserve-3d;
  
  .block { 
    position: absolute;
    left: 0;
    width: 320px;
    height: 650px;
    background-color: $block;
    z-index: 6;
    outline: 1px solid transparent;
    backface-visibility: hidden;
    clip-path: polygon(0 0, 12% 0, 26% 100%, 18% 100%);
    animation: slideDown $pageLoad forwards ease-in-out;
    
     &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $darken;
      z-index: 7;
      outline: 1px solid transparent;
      backface-visibility: hidden;
      animation: slideDown $pageLoad forwards ease-in-out .25s;
     }
    
    &:nth-of-type(1) {
      left: 170px;
      background-color: $block;
      clip-path: polygon(0 0, 18% 0, 18% 100%, 10% 100%);
    }
    
    &:nth-of-type(2) {
      left: 244px;
      background-color: $block;
      clip-path: polygon(0 0, 24% 0, 24% 100%, 10% 100%);
    }
    
    &:nth-of-type(3) {
      left: 320px;
      background-color: rgba(255,255,255, 0.15);
      clip-path: polygon(0 0, 55% 0, 55% 100%, 0% 100%);
      
      // &::after {
      //   background-color: rgba(183,65,14,0.65);
      //  }
    }
    
    &:nth-of-type(4) {
      left: 1150px;
      background-color: rgba(117, 117, 117, 0.15);
      clip-path: polygon(0 0, 31% 0, 31% 100%, 0% 100%);
      
      &::after {
        background-color: $darken;
       }
    }
    
    &:nth-of-type(5) {
       left: 1292px;
       background-color: rgba(255,255,255, 1);
       clip-path: polygon(0 0, 20% 0, 20% 100%, 0% 100%);
       animation: slideUp $pageLoad forwards ease-in-out ;
       
      &::after {
        animation: slideUp $pageLoad forwards ease-in-out 1.5s;
      }
    }
    
    &:nth-of-type(6) {
      left: 1300px;
      // background-color: rgba(72,209,204,0.95);
      background-color: green;
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
      animation: slideUp $pageLoad forwards ease-in-out ;
      
      &::after {
        background-color: $darken;
        animation: slideUp $pageLoad forwards ease-in-out 0.15s;
      }
    }
  }
}

.stats {
	position: absolute;
	// bottom: 1%;
	left: 1%;
	width: auto;
	height: 25%;
	transform: rotateZ(2deg);
	z-index: 4;

	label {
		display: none;
		visibility: hidden;
	}
	
	.stat {
    width: 700px;
    margin-bottom: -10px;
    text-align: center;
    text-transform: uppercase;
    font-size: 36px;
    color: white;
    line-height: 1;
    opacity: 0;
    
    &.-name {
		  font-size: 64px;
      animation: playerName $pageLoad forwards ease-in-out;
	  }
	  &.-position {
		  animation: playerPosition $pageLoadDelay forwards ease-in-out 0.15s;
        margin-bottom: 7px;
	  }
	}
}

// Animations
// boxes
@keyframes slideDown {
  0%, 100% {
     opacity: 0;
     transform: translateY(-100%);
  }
  20%, 80% {
    opacity: 1;
    transform: translateY(0%);
  }
}

@keyframes slideUp {
  0%, 100% {
    opacity: 0;
    transform: translateY(100%);
  }
  20%, 80% {
    opacity: 1;
    transform: translateY(0%);
  }
}

// Fades the image wrapper
@keyframes fadeBothWays {
  0%, 100%   { opacity: 0; }
  20%, 80%  { opacity: 1; }
}

// Reveals the photo 
@keyframes revealRTL {
  0%, 100% {
    opacity: 1;
    transform: translateX(0%);
  }
  21%, 82% {
    opacity: 1;
    transform: translateX(100%);
  }
}

@keyframes playerName{
  0%, 100% {
    opacity: 0;
    transform: translateY(600%);
  }
  10%, 90% {
    opacity: 1;
    transform: translateY(0%);
  }
}

@keyframes playerPosition {
  0%, 100% {
    opacity: 0;
    transform: translateY(700%);
  }
  15%, 92% {
    opacity: 1;
    transform: translateY(0%);
  }
}
</style>